import { CoreLogService } from "../log.service";
import { Sound, SoundDefault } from "./comEnvironmentMediaSound";

/** Mediendateien abspielen */

export interface Media {
  /** Erstellt einen Sound
 * @param _autoplay Automatisch abspielen
 * @param _loop Wiederholen
 * @param _volume Lautstärke (0.0 bis 1.0)
 * @param fileURL Dateipfad in der zu benutzenden Reihenfolge ohne Dateiendung (OGG + MP3 Format mit gleichem Dateinamen und unterschiedlicher Endung)
 */
  createSound(_autoplay: boolean, _loop: boolean, _volume: number, ...fileURL: string[]): Sound;
}

/** Standardimplementierung */
export class MediaDefault implements Media {

  /** Erstellt einen Sound
   * @param _autoplay Automatisch abspielen
   * @param _loop Wiederholen
   * @param _volume Lautstärke (0.0 bis 1.0)
   * @param fileURL Dateipfad in der zu benutzenden Reihenfolge ohne Dateiendung (OGG + MP3 Format mit gleichem Dateinamen und unterschiedlicher Endung)
   * @returns Sund file in Sound Interface
   */
  public createSound(_autoplay: boolean, _loop: boolean, _volume: number, fileURL: string): Sound {
    return new SoundDefault(this._coreLogService, _autoplay, _loop, _volume, fileURL);
  }

  /** Mediendateien abspielen
   * @param _coreLogService LogService
   */
  constructor(private _coreLogService: CoreLogService) {
  }
}
